import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;


export const createOrder = async (createObj, room) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(`${BACKEND_URL}/orders/public?room=${room}`,
    createObj,
    {
        withCredentials: true,
        successMessage: "สั่งซื้อสำเร็จ กรุณารอสักครู่"
    });
    return res;
}
